import React from 'react';
import { Container, Typography, Grid, Card, CardContent } from '@mui/material';
import StatsCard from '../../components/Dashboard/StatsCard';

const AnalyticsPage = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" gutterBottom>
        Analytics Dashboard
      </Typography>
      <Typography variant="body1" color="text.secondary" gutterBottom>
        Manufacturing intelligence and performance metrics
      </Typography>

      <Grid container spacing={3} sx={{ mt: 2 }}>
        <Grid item xs={12} md={6} lg={3}>
          <StatsCard
            title="Active Partners"
            value="12"
            subtitle="Manufacturing partners"
          />
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <StatsCard
            title="Orders Processed"
            value="247"
            subtitle="This month"
          />
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <StatsCard
            title="Tech Packs Generated"
            value="89"
            subtitle="CLO3D extractions"
          />
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <StatsCard
            title="Production Time"
            value="1.2h"
            subtitle="Average concept-to-production"
          />
        </Grid>
      </Grid>

      <Card sx={{ mt: 3 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Manufacturing Intelligence
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Advanced analytics for mass customization workflows coming soon.
          </Typography>
        </CardContent>
      </Card>
    </Container>
  );
};

export default AnalyticsPage;